<template>
  <div v-if="!can('Booking Charges', 'no access')">
    <fieldset :disabled="!can('Booking Charges', 'manage')">
      <div v-for="(item, idx) in items" :key="idx">
          <ShipmentPrototypeItem
            :visible="item.flag"
            :expanded="false"
            :collapsible="false"
            :key="item.id"
            :id="item.id"
            @delete="removeItem"
            @toggleHazard="toggleHazardous(idx)"
          >
            <template v-slot:title>
              <b-input-group>
                <b-form-input
                  aria-label="Charge Name"
                  placeholder="Charge Name"
                  class="text-center"
                  v-model.number="item.name"
                ></b-form-input>
                <b-form-input
                  aria-label="Amount"
                  placeholder="Amount"
                  class="col-3 text-center"
                  type="number"
                  step="0.01"
                  min="0.0"
                  v-model.number="item.amount"
                  number
                ></b-form-input>
              </b-input-group>
            </template>
          </ShipmentPrototypeItem>
      </div>
      <hr class="my-0">
      <b-button
        variant="outline-dark"
        class="mt-3 text-xs"
        @click="addNewItem()"
      >
        Add Charge
      </b-button>
    </fieldset>
  </div>
</template>

<script>
import ShipmentPrototypeItem from './ShipmentPrototypeItem.vue';

export default {
  name: 'ShipmentPrototypeChargesList',
  props: ['items'],
  methods: {
    removeItem(id) {
      this.$emit('remove', id);
    },
    addNewItem() {
      this.$emit('add');
    },
    toggleHazardous(idx) {
      this.$emit('toggleHazard', idx);
    },
  },
  components: { ShipmentPrototypeItem },
};
</script>

<style scoped>

</style>
